export default "__VITE_ASSET__CayQz6BE__"